// extracted by mini-css-extract-plugin
export default {"filesRow":"PolicyForm_filesRow__ond1I","policy-version":"PolicyForm_policy-version__+84vE","policy-language":"PolicyForm_policy-language__WoB1d"};